import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import ProcessSlider30Sec from '../../../components/sliders/ProcessSlider30Sec';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import Benefits30Sec from '../../../components/video-production/explainer-videos/Benefits30Sec';
import SolveProblems30Sec from '../../../components/video-production/explainer-videos/SolveProblems30Sec';

lazyload({
  width: '100%',
});

const ExplainerVideos30Second = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - 30 Second Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/thirty-second-explainer-video" />
        <meta
          name="description"
          content="Experience efficiency with our 30-second explainer video. Grab attention, inform, and leave viewers wanting more. Dive in now for an engaging experience."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/thirty-second-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - 30 Second Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Experience efficiency with our 30-second explainer video. Grab attention, inform, and leave viewers wanting more. Dive in now for an engaging experience."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/thirty-second-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - 30 Second Explainer Video | Prodigi",
              "description": "Experience efficiency with our 30-second explainer video. Grab attention, inform, and leave viewers wanting more. Dive in now for an engaging experience",
              "url": "https://weprodigi.com/video-production/thirty-second-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "30 Second Explainer Video Production - Prodigi",
                    "item": "https://weprodigi.com/video-production/thirty-second-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "30 Second Explainer Video Production",
                "description": "Experience efficiency with our 30-second explainer video. Grab attention, inform, and leave viewers wanting more. Dive in now for an engaging experience",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1100",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Martin Roland"
                    },
                    "datePublished": "2023-09-6",
                    "reviewBody": "Prodigi Agency's 30-second explainer video is simply outstanding! It's concise, engaging, and beautifully crafted. They've truly captured the essence of our brand in just half a minute."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Billie Thornefield"
                    },
                    "datePublished": "2023-12-29",
                    "reviewBody": "We couldn't be happier with the 30-second explainer video produced by Prodigi Agency! Their team took the time to understand our brand and objectives, and it clearly showed in the final result. The video is engaging, informative, and perfectly aligned with our brand identity. We're incredibly impressed with Prodigi's professionalism and creativity!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Anastasia Chanmurk"
                    },
                    "datePublished": "2024-01-22",
                    "reviewBody": "Prodigi Agency's 30-second explainer video exceeded all our expectations! Not only did they deliver a visually stunning video, but they also perfectly captured the essence of our brand. Working with them was a breeze, and we couldn't be happier with the final result!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/thirty-second-explainer/thirty-second-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              30 Second Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/thirty-second-explainer-video',
                name: '30 second Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A 30 second video conveys a message in the most effective way. For grabbing the attention of an audience, this short explainer video
                  format is perfect. 30 seconds can serve to introduce your idea in every aspect. Scroll down for more information!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What is a 30 Sec Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/oepRRYu_-sU?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Card | Typography Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A 30 second video is a short, engaging video clip. It's made for easy explaining complex ideas. Its vivid visuals and simple language
                will attract attention. High-quality videos will communicate all key messages at the time when the viewers decide on further
                engagement. A 30 second explainer video gets the most important detail that helps to increase customers' experience. It is a powerful
                addition to digital marketing strategies.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A 30 second video is a short, engaging video clip. It's made for easy explaining complex ideas. Its vivid visuals and simple
                  language will attract attention. High-quality videos will communicate all key messages at the time when the viewers decide on
                  further engagement. A 30 second explainer video gets the most important detail that helps to increase customers' experience. It is a
                  powerful addition to digital marketing strategies.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use 30 sec Explainer Video?
            </h2>
            <p className={'mt-20'}>
              In the virtual rush, it can be harder to grab the audience's attention and make them continue watching something. 30 second explainer
              video is a wonderful solution for grabbing attention, making impact on visual and auditory memory․
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/Gu6GKjHJzLw?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>SkyeCapital | Whiteboard Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Do you want to engage your audience in your dynamic game with a short marketing video? A 30 second explainer video can be your
                  visiting card. Use this short video in social media ads, landing pages, e-commerce or retail platforms, email marketing, etc. It
                  will keep the attention of your audience during the whole video.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Do you want to engage your audience in your dynamic game with a short marketing video? A 30 second explainer video can be your
                    visiting card. Use this short video in social media ads, landing pages, e-commerce or retail platforms, email marketing, etc. It
                    will keep the attention of your audience during the whole video.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  What can make your education or training system better? In our times, long lectures and explanations might be boring. A 30 sec
                  explainer video is the piece of your puzzle! Engage your audience by using a 30 sec explainer video made with motion graphics, 2D\3D
                  animation, or live actions․ It’s a perfect addition to your online courses, e-learning materials, and training modules.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    What can make your education or training system better? In our times, long lectures and explanations might be boring. A 30 sec
                    explainer video is the piece of your puzzle! Engage your audience by using a 30 sec explainer video made with motion graphics,
                    2D\3D animation, or live actions․ It’s a perfect addition to your online courses, e-learning materials, and training modules.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/iusw_NSnrE0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Perkin Elmer | Manufacturing Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/Rxx22BuE66A?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>HopShop | Software Solution Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Software and Technology</h3>
                <p className={'mt-16 hidden md:block'}>
                  It’s important to keep up in the fast-growing software and technology industry. We know the best solution. A 30 sec explainer video
                  helps you with displaying features and advantages of a new technology product or software. Its motion graphics, 2D/3D animation, or
                  live-action short videos highlight the main purpose of your product. Keep tuned to your audience of software and technology
                  novelties.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    It’s important to keep up in the fast-growing software and technology industry. We know the best solution. A 30 sec explainer
                    video helps you with displaying features and advantages of a new technology product or software. Its motion graphics, 2D/3D
                    animation, or live-action short videos highlight the main purpose of your product. Keep tuned to your audience of software and
                    technology novelties.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of a 30 Sec Explainer Video
            </h2>
            <p className={'mt-20'}>
              Why choose a 30 second video to introduce your business or product? Here are the main benefits that can make an impact on your audience.
            </p>
            <Suspense fallback={`Loading...`}>
              <Benefits30Sec />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our 30 Sec Explainer Video Production Process
            </h2>
            <ProcessSlider30Sec />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-24 lg:text-36'
              }
            >
              CALCULATE YOUR 30 SECOND EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How 30 Second Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              30 second explainer video production is a powerful tool for engaging audiences and maintaining communication. Here is how it can serve
              your business goals.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblems30Sec />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">Why Choose Us for Your 30 Sec Explainer Video?</h2>
            <Why
              content={[
                {
                  title: 'We dive deeply into your ideas',
                  answer:
                    'It’s important to understand all the advantages of your offer and choose the most captivating part of it. Deeply analyzing your product or service, our experts will craft the main message and highlight it in the most suitable light. Our customized solutions will fully customize the 30 second explainer videos, improving engagement and lasting impact. With the help of our digital marketing specialists, we’ll find the best online platform for your video.',
                },
                {
                  title: 'We provide a creative approach',
                  answer:
                    'Mixing the flexibility of video format and the big potential of our company makes it possible to add originality to your offer. Our enthusiastic video production team can provide unique dynamism to the 30 second explainer video ideas, visualizing different points effectively.',
                },
                {
                  title: 'We manage the entire project',
                  answer:
                    'Our experienced project management team will coordinate all the processes and ensure the necessary communication. Managing the project schedule guarantees  that your business goals will be completed on time.',
                },
                {
                  title: 'We don’t require prepayment',
                  answer:
                    'We chose the milestone payment approach for our 30 second explainer video services because we are sure it offers the best benefits for both our team and our clients.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What should be included in a 30 second explainer video?',
                    answer:
                      'The video production process includes a short script that captures the attention of your target audience. Then, display how the solution you are offering solves their problem. The video includes the most significant messages of your offer.',
                  },
                  {
                    title: 'What is the ideal style for a 30 second explainer video? ',
                    answer:
                      'It depends on the idea of your message, chosen style should effectively convey messages, explain complex information quickly. The video should talk about the main benefits of the product in a simple manner and simple style.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How much does it cost to create a 30 second explainer video?',
                    answer: 'The average cost of a 30 second video starts at $1200..',
                  },
                  {
                    title: 'What are 30 second videos good for?',
                    answer:
                      "30 second video format quickly conveys concise messages, introduces a product or service, or captures viewers' attention in a fast-paced digital environment.",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideos30Second;
